const en_master_finance = {
    "": "finance"
}

export default en_master_finance;